import React, { ReactNode, useState } from "react";
import {
  StyleSheet,
  View,
  Text,
  StyleProp,
  ViewStyle,
  TouchableOpacity,
  Image,
} from "react-native";
import { fonts } from "../common/styles/fonts";
import { colors } from "../common/styles/colors";
import { getPlaceTags, LikedFollowers, TagsWithDivider } from "./PlaceCard";
import { CommonButton } from "./buttons";

import { ReactComponent as MapIcon } from "../common/svg/pin.svg";
import { ReactComponent as MapIconLight } from "../common/svg/map_light.svg";
import { ReactComponent as ArrowBlack } from "../common/svg/arrow_short_black.svg";
import { ReactComponent as DefaultPhoto } from "../common/svg/gadder_icon.svg";

import { localeUrlHandler } from "./MapPin";
import { FullPlaceType } from "../api/models/place";

export const PlaceCardSmall = ({
  light = false,
  place,
  style,
  onPress,
  RightIcon,
  mapMod = false,
  additionalText = "",
  onGetDirectionPress,
}: {
  light?: boolean;
  place?: FullPlaceType;
  style?: StyleProp<ViewStyle>;
  RightIcon?: ReactNode | React.Component;
  onPress?: () => void;
  mapMod?: boolean;
  additionalText?: string;
  onGetDirectionPress?: () => void;
}) => (
  <TouchableOpacity disabled={!onPress} style={style} onPress={onPress}>
    <View style={[styles.container, mapMod && { marginBottom: 12 }]}>
      <>
        <View style={[{ flexDirection: "row", alignItems: "center", flex: 1 }]}>
          {place ? (
            place.picture_1 && (
              <Image
                style={styles.image}
                source={{ uri: localeUrlHandler(place.picture_1) }}
              />
            )
          ) : (
            <DefaultPhoto width={82} height={82} />
          )}
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              alignSelf: "stretch",
              flex: 1,
            }}
          >
            <View
              style={[
                styles.placeInfo,
                { justifyContent: place ? "space-between" : "space-evenly" },
              ]}
            >
              <Text
                numberOfLines={1}
                style={[
                  fonts.mediumLargeText_regular,
                  { fontWeight: "700", color: colors.black },
                  light && { color: colors.white },
                ]}
              >
                {place ? place.name : "Gaddering..."}
              </Text>
              {place && (
                <CommonButton
                  LeftIcon={
                    light ? (
                      <MapIconLight
                        height={13}
                        width={11}
                        style={{ marginRight: 5 }}
                      />
                    ) : (
                      <MapIcon
                        height={13}
                        width={11}
                        style={{ marginRight: 5 }}
                      />
                    )
                  }
                  textStyle={{ flex: 1 }}
                  style={{ maxWidth: 200 }}
                  title={place.address}
                  type={light ? "white" : "black"}
                  size={"small"}
                />
              )}
              {mapMod || additionalText ? (
                <Text
                  numberOfLines={1}
                  style={[
                    fonts.smallText_regular,
                    { color: colors.black },
                    light && { color: colors.white },
                  ]}
                >
                  {additionalText}
                </Text>
              ) : (
                place && (
                  <TagsWithDivider
                    tags={getPlaceTags(place)}
                    textStyle={[
                      { color: colors.black, fontWeight: "400" },
                      light && { color: colors.white },
                    ]}
                    dividerStyle={[
                      { backgroundColor: colors.black },
                      light && { backgroundColor: colors.white },
                    ]}
                  />
                )
              )}
            </View>

            {mapMod && (
              <ArrowBlack style={{ transform: [{ rotateZ: "180deg" }] }} />
            )}
          </View>
        </View>

        {RightIcon}
      </>
    </View>

    {mapMod && place && (
      <>
        <LikedFollowers
          hideArrow={mapMod}
          textStyle={{ color: colors.black }}
          style={{ marginBottom: 12 }}
          userList={place.also_liked}
        />

        <View style={styles.container}>
          <TagsWithDivider
            textStyle={{ color: colors.black }}
            dividerStyle={{ backgroundColor: colors.black }}
            style={{ flex: 1 }}
            tags={getPlaceTags(place)}
          />

          <CommonButton
            onPress={onGetDirectionPress}
            title={"Get Directions"}
            type={"black"}
            size={"small"}
          />
        </View>
      </>
    )}
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  image: {
    justifyContent: "center",
    alignItems: "center",
    width: 82,
    height: 82,
    borderRadius: 41,
  },
  placeInfo: {
    alignSelf: "stretch",
    paddingLeft: 8,
    alignItems: "flex-start",
    flex: 1,
  },
});
